import React, { ReactElement, Suspense, useEffect } from "react";
import "./styles/globals.less";
import { BrowserRouter, Switch, useHistory } from "react-router-dom";
import { Col, ConfigProvider, Layout, Spin } from "antd";
import StateContext from "@context/StateContext";
import HomeRouter from "@routers/HomeRouter";
import { Cookies, CookiesProvider, useCookies } from "react-cookie";
const getCookies = new Cookies();

function SuspenseContent(): JSX.Element {
  return (
    <>
      <Layout
        style={{
          minWidth: 400,
          minHeight: "100vh",
        }}
      >
        <Col className="spin-load">
          <Spin tip="Loading" />
        </Col>
      </Layout>
    </>
  );
}

function App(): ReactElement {
  return (
    <>
      <ConfigProvider>
        <CookiesProvider>
          <BrowserRouter>
            <Suspense fallback={<SuspenseContent />}>
              <StateContext.Provider value={{}}>
                <Switch>{HomeRouter}</Switch>
              </StateContext.Provider>
            </Suspense>
          </BrowserRouter>
        </CookiesProvider>
      </ConfigProvider>
    </>
  );
}

export default App;
